/**
 * Bruku Language Selector — real locale switcher, styled as the same
 * dropdown pill as the Bruku currency selector. Unlike currency (which is
 * purely cosmetic), selecting a language here submits Shopify's native
 * localization form, which reloads the page with translated content.
 */
(function () {
  'use strict';

  function setupSelector(root) {
    var trigger = root.querySelector('.bruku-currency__trigger');
    var menu = root.querySelector('.bruku-currency__menu');
    var input = root.querySelector('[data-bruku-language-input]');
    var form = root.querySelector('form');
    if (!trigger || !menu || !input || !form || root.__brukuLangBound) return;
    root.__brukuLangBound = true;

    function close() {
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function open() {
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (root.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    menu.querySelectorAll('[role="option"]').forEach(function (option) {
      option.addEventListener('click', function () {
        var code = option.getAttribute('data-language');
        if (!code || code === input.value) {
          close();
          return;
        }
        input.value = code;
        close();
        form.submit();
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function init() {
    document.querySelectorAll('[data-bruku-language]').forEach(setupSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
